import { render, staticRenderFns } from "./NationalTrademarkOwnerList.vue?vue&type=template&id=990e98fc&"
import script from "./NationalTrademarkOwnerList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkOwnerList.vue?vue&type=style&index=0&id=990e98fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports